/* TORVAULT 二段階販売 — 入荷待ち登録 / 数量限定予約(依存ライブラリなし)
   - 入荷待ち: 開閉、希望カラー/数量→contact[tags]への合成、ハニーポット、カラー完売時のプリセレクト
   - 予約: 数量上限クランプ、通常商品との混在ガード(既定ブロック)
   - 固定フッター: 販売モードに応じてCTAラベル/動作を切替 */
(function () {
  'use strict';
  var xcMessages = window.xcGlobalMessages || {"mixed_order":"予約商品と通常商品は発送時期が異なるため、別々にご注文ください。(カートを空にするか、先に現在のご注文を完了してください)","closed":"受付終了","priority_notice":"優先案内を受け取る","preorder_order":"予約注文する"};
  if (window.__xcLifecycleInit) return;
  window.__xcLifecycleInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var sec = document.querySelector('[data-xc-purchase]');
    if (!sec) return;
    var mode = sec.dataset.xcSaleMode || 'normal';
    var waitlist = document.querySelector('[data-xc-waitlist]');

    /* ---------- 入荷待ち: 専用ページ(/pages/xenith-core-priority)への導線 ---------- */
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var WAITLIST_URL = routeRoot + 'pages/xenith-core-priority';
    function goWaitlist(colorVal) {
      window.location.href = WAITLIST_URL + (colorVal ? '?color=' + encodeURIComponent(colorVal) : '');
    }
    window.xcOpenWaitlist = goWaitlist;
    if (sec.dataset.xcWaitlistEnabled !== 'false') {
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-xc-card-notify], [data-xc-form-notify]');
        if (!t) return;
        e.preventDefault();
        e.stopPropagation();
        var card = t.closest('.xc-colors__swatch');
        var input = card && card.querySelector('input[type="radio"]');
        var name = input && (input.dataset.xcName || '').toUpperCase();
        var color = null;
        if (name && /BLACK/.test(name)) color = 'BLACK';
        else if (name && /SILVER/.test(name)) color = 'SILVER';
        else if (name && /GOLD/.test(name)) color = 'GOLD';
        goWaitlist(color);
      }, true);
    }

    /* ---------- 予約: 数量上限+混在ガード ---------- */
    var cartHasNormal = false, cartHasPreorder = false;
    function refreshCartFlags() {
      if (!window.fetch) return;
      fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        cartHasNormal = false; cartHasPreorder = false;
        (c.items || []).forEach(function (it) {
          if (it.properties && it.properties['予約商品']) cartHasPreorder = true;
          else cartHasNormal = true;
        });
      }).catch(function () {});
    }
    refreshCartFlags();
    document.addEventListener('xc:cart:added', function () { setTimeout(refreshCartFlags, 400); });

    var form = sec.querySelector('form[data-xc-product-form]');
    if (form) {
      var poLimit = parseInt(sec.dataset.xcPoLimit || '0', 10);
      var qtySel = form.querySelector('[data-xc-po-qty]');
      if (qtySel && poLimit > 0) {
        qtySel.addEventListener('change', function () {
          var v = parseInt(qtySel.value, 10);
          if (v > poLimit) qtySel.value = String(poLimit);
        });
      }
      /* 混在ガード(既定: 予約と通常は同一注文にしない)。既存submitハンドラより先に評価 */
      if (sec.dataset.xcAllowMixed !== 'true') {
        form.addEventListener('submit', function (e) {
          var conflict = (mode === 'preorder' && cartHasNormal) || (mode === 'normal' && cartHasPreorder);
          if (!conflict) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var status = form.querySelector('[data-xc-add-status]');
          if (status) status.textContent = xcMessages.mixed_order;
        }, true);
      }
    }

    /* ---------- 固定フッター連動 ----------
       フッターJSはバリアント切替のたびに root.dataset.xcSpfLabel をラベルへ書き戻すため、
       dataset側も更新して上書き競合を防ぐ(本スクリプトはフッターJSより先に初期化される) */
    var spfRoot = document.querySelector('[data-xc-spf]');
    var spfCta = document.querySelector('[data-xc-spf-cta]');
    var spfLabel = document.querySelector('[data-xc-spf-cta-label]');
    if (spfRoot && spfCta && mode === 'waitlist' && sec.dataset.xcWaitlistEnabled === 'false') {
      /* 入荷待ち登録の受付終了: 導線を出さず押せない表示に固定(表記はセクション設定) */
      var closedLabel = sec.dataset.xcWaitlistClosedLabel || xcMessages.closed;
      spfRoot.dataset.xcSpfLabel = closedLabel;
      if (spfLabel) spfLabel.textContent = closedLabel;
      spfCta.disabled = true;
      spfCta.setAttribute('aria-disabled', 'true');
    } else if (spfRoot && spfCta && mode === 'waitlist') {
      spfRoot.dataset.xcSpfLabel = xcMessages.priority_notice;
      if (spfLabel) spfLabel.textContent = xcMessages.priority_notice;
      spfCta.disabled = false;
      spfCta.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.xcOpenWaitlist) window.xcOpenWaitlist();
      }, true);
    } else if (spfRoot && spfCta && mode === 'preorder') {
      spfRoot.dataset.xcSpfLabel = xcMessages.preorder_order;
      if (spfLabel) spfLabel.textContent = xcMessages.preorder_order;
    }
  });
})();
